import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductNamesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductNamesReducer.productsFeatureKey]
);

export const getStaticDataProductNamesFailure = createSelector(
  getStaticDataProductNamesState,
  staticDataCountriesReducer.fromStaticDataProductNamesReducer.getProductNamesFailure
);

export const getStaticDataProductNamesResponse = createSelector(
  getStaticDataProductNamesState,
  staticDataCountriesReducer.fromStaticDataProductNamesReducer.getProductNamesResponse
);
